
import { polishTranslate } from "@book-searcher/data";
import { defineComponent } from "vue";
export default defineComponent({
  name: "Select",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      default: "",
    },
    values: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  setup() {
    return { polishTranslate };
  },
});
